import { apiClient } from 'modules/core/lib/mobx-rest'
import { Collection } from 'modules/core/lib/mobx-rest'

import EmployeeReporteesAnalytics from 'modules/org_chart/store/models/EmployeeReporteesAnalytics'

class EmployeeReporteesAnalyticsCollection extends Collection<EmployeeReporteesAnalytics> {
  get cacheKey(): string {
    return 'employeeReporteesAnalytics'
  }

  model() {
    return EmployeeReporteesAnalytics
  }

  async fetchById(employeeId: string): Promise<void> {
    if (this.get(employeeId)) return

    const nextAnalytic = await apiClient().get(`${this.model().urlRoot()}/${employeeId}`)

    this.set([nextAnalytic])
  }
}

const singleton = new EmployeeReporteesAnalyticsCollection()

export default singleton
